import { auth } from "../auth/auth";
import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";

export default function PublicRoute({ children }) {
  const [user, loading] = useAuthState(auth);

  if (loading) return null;

  // If already logged in, don't show login page
  if (user) return <Navigate to="/dashboard" />;

  return children;
}
